import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import PageHeader from '../../components/public/PageHeader';
import { publicApi } from '../../services/api';

export default function BlogPage() {
  const [page, setPage] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      publicApi.getPage('blog').catch(() => ({ data: { data: null } })),
      publicApi.getPosts().catch(() => ({ data: { data: [] } })),
    ]).then(([pageRes, postsRes]) => {
      setPage(pageRes.data?.data || null);
      const postsData = postsRes.data?.data?.data || postsRes.data?.data || [];
      setPosts(postsData);
    }).finally(() => setLoading(false));
  }, []);

  const formatDate = (dateStr) => {
    try {
      return new Date(dateStr).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch { return dateStr; }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <PageHeader title={page?.title || 'Blog'} subtitle={page?.content || 'Tips dan artikel seputar kebersihan & lingkungan'} />
      <section className="py-16 bg-bg-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center py-20"><div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>
          ) : posts.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map(post => (
                <Link key={post.id} to={`/blog/${post.slug}`} className="bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden group border border-gray-100">
                  <div className="h-56 bg-gradient-to-br from-brand/20 via-white to-primary/20 flex items-center justify-center text-6xl overflow-hidden">
                    {post.image_url ? (
                      <img src={post.image_url} alt={post.title} className="w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-105" />
                    ) : (
                      <span className="text-4xl">📝</span>
                    )}
                  </div>
                  <div className="p-6">
                    <span className="text-xs text-gray-400">{formatDate(post.created_at)}</span>
                    <h3 className="text-lg font-bold text-gray-900 mt-2 mb-2 group-hover:text-primary transition-colors line-clamp-2">{post.title}</h3>
                    <p className="text-sm text-gray-500 line-clamp-3">{post.excerpt || post.body?.replace(/<[^>]*>/g, '').substring(0, 150) + '...'}</p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20 text-gray-400">
              <span className="text-5xl block mb-4">📝</span>
              <p className="text-lg">Belum ada artikel.</p>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
